/**
 * Nutrition Dashboard
 * Comprehensive nutrition overview for client detail page
 */

import { MacroProgressInsights } from './MacroProgressInsights';
import { TodaysMacroProgress } from './TodaysMacroProgress';
import { RecentMealsPreview } from './RecentMealsPreview';
import { NutritionQuickActions } from './NutritionQuickActions';
import { SmartSuggestions } from './SmartSuggestions';

interface NutritionDashboardProps {
  clientId: string;
  onConfigureClick?: () => void;
}

export function NutritionDashboard({
  clientId,
  onConfigureClick,
}: NutritionDashboardProps) {
  return (
    <div className="space-y-6">
      {/* Top Row: Today's Progress (full width) */}
      <TodaysMacroProgress clientId={clientId} />

      {/* Middle Row: Recent Meals + Smart Suggestions */}
      <div className="grid md:grid-cols-2 gap-4">
        {/* Recent Meals */}
        <RecentMealsPreview clientId={clientId} />

        {/* Smart Suggestions (Sprint 3) */}
        <SmartSuggestions clientId={clientId} />
      </div>

      {/* Quick Actions */}
      <NutritionQuickActions
        clientId={clientId}
        onConfigureClick={onConfigureClick}
      />

      {/* Bottom: Progress Insights */}
      <MacroProgressInsights
        clientId={clientId}
        onSetupClick={onConfigureClick}
        onAdjustClick={onConfigureClick}
      />
    </div>
  );
}
